import request from "../request";

export const getPhotos = () => 
  request.get('photo-management').then((res) => res);

export const deletePhoto = (file) =>
  request.post("photo-management/delete", { file }).then((res) => res);

export const deletePhotos = (files) =>
  request.post("photo-management/delete/bulk", { files }).then((res) => res);

export const presigneUrl = (files) =>
  request.post("photo-management/presign-url", { files }).then((res) => res);

export const insertLogUpload = (files) =>
  request.post("photo-management/upload/log", { files }).then((res) => res);




